module.exports = __webpack_public_path__ + "img/punchline-white-label.1a45ad2b.svg";